/**
 *  @class
 *  @function ProductRecommendations
 */
if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.parent = this.closest('.product-recommendations--parent');
      this._onCartOpen = () => setTimeout(() => this.parent?.classList.add('active'), 40);
      this._onCartClose = () => this.parent?.classList.remove('active');
    }

    fetchProducts() {
      const url = (this.dataset.url || '').trim();
      if (!url) { 
        this.classList.add('product-recommendations--loaded');
        if (this.parent) {
          this.parent.classList.add('product-recommendations--full');
          if (document.body.classList.contains('open-cart')) this.parent.classList.add('active');
        }
        return;
      }

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;

            if (this.parent) {
              this.parent.classList.add('product-recommendations--full');
              if (document.body.classList.contains('open-cart')) this.parent.classList.add('active');
            }
          }

          this.classList.add('product-recommendations--loaded');
        })
        .catch(e => {
          console.error(e);
          this.classList.add('product-recommendations--loaded');
        });
    }

    connectedCallback() {
      this.fetchProducts();
      document.addEventListener('cart-drawer:open', this._onCartOpen);
      document.addEventListener('cart-drawer:close', this._onCartClose);
    }

    disconnectedCallback() {
      document.removeEventListener('cart-drawer:open', this._onCartOpen);
      document.removeEventListener('cart-drawer:close', this._onCartClose);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
